import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { setMsalInstance } from './api';
import App from './App';
import './index.css';

export const msalInstance = new PublicClientApplication(msalConfig);
// initialize() must be awaited before any MSAL API call.
// MsalProvider also calls it internally, but api.js interceptors may fire
// before that completes — so we store the promise and await it there.
const msalReadyPromise = msalInstance.initialize();
setMsalInstance(msalInstance, msalReadyPromise);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <MsalProvider instance={msalInstance}>
    <App />
  </MsalProvider>
);
